import { render, staticRenderFns } from "./DataListCount.vue?vue&type=template&id=52d1a15e&scoped=true&"
import script from "./DataListCount.vue?vue&type=script&lang=js&"
export * from "./DataListCount.vue?vue&type=script&lang=js&"
import style0 from "./DataListCount.vue?vue&type=style&index=0&id=52d1a15e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1a15e",
  null
  
)

export default component.exports